import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";


const getList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.flatFee.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteFlatFee = (id: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.delete.replace('{flatFeeId}', `${id}`);

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const createFlatFee = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.create;

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('POST', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const updateFlatFee = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.flatFee.update.replace('{flatFeeId}', `${data.flatFeeId}`);

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('PUT', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

export const flatFeeService = {
	getList,
	deleteFlatFee,
	createFlatFee,
	updateFlatFee,
};
